import React from 'react';
import Message from '../message/Message';

const ServiceErrorMessage = ({ heading, message }) => (
    <Message
        heading={heading}
        body={
            <span>
                <span>{message}</span>
            </span>
        }
        type="error"
    />
);

export default ServiceErrorMessage;



// WEBPACK FOOTER //
// ./src/components/modals/ServiceErrorMessage.js